import { useState, useEffect } from 'react'
import { useTheme } from 'styled-components'

export const useIsMobile = () => {
  const theme = useTheme()
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < theme.breakpoints.md)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < theme.breakpoints.md)
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [theme.breakpoints.md])

  return isMobile
}
